export default "__VITE_ASSET__7pzdTkhd__"